module.exports = __webpack_public_path__ + "img/lochgestaltung.081ff719.webp";